import React from 'react';
import { LandingPage } from './views'

const app: React.FC = () => (
	<LandingPage />
)

export default app